import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';

import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';

import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
import "../../../styles/Auth/coupon.css";

const OfferPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const initialStoreId = sessionStorage.getItem("currentStoreId") ||
        (role === "Admin" ? adminStoreIds[0] || "" : "");
    const isAddCoupon = location.pathname === '/coupons/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [stores, setStores] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const sessionToken = sessionStorage.getItem("Token");
    const [couponsToDelete, setCouponsToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [loading, setLoading] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCouponId, setEditCouponId] = useState(null);
    const [formData, setFormData] = useState({
        couponCode: "",
        useLimit: "",
        startTime: "",
        endTime: "",
        discountType: "",
        percentageOrAmount: "",
        minimumPurchaseAmount: "",
        daysAppliedon: [],
        description: "",
        storeId: initialStoreId,
    });
    const days = [
        { key: "Sunday", label: "S" },
        { key: "Monday", label: "M" },
        { key: "Tuesday", label: "T" },
        { key: "Wednesday", label: "W" },
        { key: "Thursday", label: "T" },
        { key: "Friday", label: "F" },
        { key: "Saturday", label: "S" },
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Coupon Code',
        'Start On',
        'Expire On',
        'Amount Or Percentage',
        'Status',
        'Action',
    ];
    const handleOpen = (couponId) => {
        setCouponsToDelete(couponId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCouponsToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    const handleAddCoupon = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            // Build the full image URL
            const couponData = {
                storeId: formData.storeId,
                couponCode: formData.couponCode,
                startTime: formData.startTime,
                useLimit: formData.useLimit,
                endTime: formData.endTime,
                discountType: formData.discountType,
                percentageOrAmount: formData.percentageOrAmount,
                minimumPurchaseAmount: formData.minimumPurchaseAmount,
                daysAppliedon: formData.daysAppliedon,
                description: formData.description,
            };
            console.log("Sending coupon data:", couponData);

            const response = await postData('coupons/', couponData, token);

            toast.success(response.message || 'Coupon added successfully');
            setFormData({

            });
            navigate("/coupons");
            triggerRefresh();
        }
        catch (error) {
            console.error('Add Coupon Error:', error);
            toast.error(error.message || 'Add Coupon Failed');
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem("Token");
        fetchCoupon(currentPage, limit, searchQuery, token, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId]);

    const fetchCoupon = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            couponCode: searchQuery?.trim() || ""
        }
        if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('coupons/coupons', params, sessionToken);
            const resultsWrapper = response?.data;
            const couponsList = resultsWrapper?.results || [];
            const totalCount = resultsWrapper?.totalItems || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setCoupons(couponsList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Coupons");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCoupon = async (e) => {
        debugger;
        try {
            const token = sessionStorage.getItem("Token");
            const updatedCouponData = {
                couponCode: formData.couponCode,
                startTime: formData.startTime,
                endTime: formData.endTime,
                discountType: formData.discountType,
                percentageOrAmount: formData.percentageOrAmount,
                minimumPurchaseAmount: formData.minimumPurchaseAmount,
                useLimit: formData.useLimit,
                daysAppliedon: formData.daysAppliedon,
                description: formData.description,
            };

            console.log("Updating Coupon with data:", updatedCouponData);

            const response = await putData(`coupons/coupon/${editCouponId}`, updatedCouponData, token);

            toast.success(response.message || 'Coupon updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                couponCode: '',
                startTime: '',
                endTime: '',
                discountType: '',
                percentageOrAmount: '',
                minimumPurchaseAmount: '',
                daysAppliedon: '',
                description: '',
            });
            setIsEditMode(false);
            fetchCoupon(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating coupon.");
        }
    };
    const handleDeleteCoupon = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('Token');
            const response = await deleteData(`coupons/coupon/${couponsToDelete}`, token);
            toast.success(response.message || "Coupon deleted successfully");
            setCouponsToDelete(null);
            fetchCoupon(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Coupon");
        }
    }

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className="coupon-layout">
            <div className="coupon-content">
                <div className="coupon-main">
                    {isAddCoupon ? (
                        <div className="add-coupon-form">
                            <h3>Add Coupon</h3>
                            <form className="coupon-form">
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label className="input-label">Branch Name</label>
                                        <select
                                            className="category-input"
                                            value={formData.storeId || ""}
                                            onChange={(e) => {
                                                const storeId = e.target.value;
                                                setSelectedStoreId(storeId);
                                                setFormData(prev => ({ ...prev, storeId }));
                                                sessionStorage.setItem("currentStoreId", storeId);
                                                window.dispatchEvent(new Event("storeChanged"));
                                            }}
                                        >
                                            <option value="">Select Branch</option>
                                            {stores
                                                .filter(store =>
                                                    role === "SuperAdmin" ||
                                                    (role === "Admin" && adminStoreIds.includes(store._id))
                                                )
                                                .map(store => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="Coupon-form-group">
                                        <label htmlFor="couponCode" className="input-label">
                                            Coupon Code
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter coupon code"
                                            className="Coupon-input"
                                            value={formData.couponCode}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, couponCode: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Coupon-form-group">
                                        <label htmlFor="useLimit" className="input-label">
                                            Use Limit
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter use limit"
                                            className="Coupon-input"
                                            value={formData.useLimit}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, useLimit: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label htmlFor="startTime" className="input-label">
                                            Start Time
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className="Coupon-input"
                                            value={formData.startTime ? formData.startTime.toISOString().slice(0, 16) : ''}
                                            onChange={(e) => setFormData({ ...formData, startTime: new Date(e.target.value) })}
                                        />
                                    </div>
                                    <div className="Coupon-form-group">
                                        <label htmlFor="useLimit" className="input-label">
                                            End Time
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className="Coupon-input"
                                            value={formData.endTime ? formData.endTime.toISOString().slice(0, 16) : ''}
                                            onChange={(e) => setFormData({ ...formData, endTime: new Date(e.target.value) })}
                                        />
                                    </div>
                                </div>
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label htmlFor="discountType" className="input-label">
                                            Discount Type
                                        </label>
                                        <select
                                            id="discountType"
                                            className="Coupon-input"
                                            value={formData.discountType}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, discountType: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Discount Type</option>
                                            <option value="percentage">Percentage</option>
                                            <option value="fixed">Fixed</option>
                                        </select>
                                    </div>
                                    <div className="Coupon-form-group">
                                        <label htmlFor="percentageOrAmount" className="input-label">
                                            {formData.discountType === "percentage" ? "Percentage (%)" : "Amount (₹)"}
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            placeholder={
                                                formData.discountType === "percentage"
                                                    ? "Enter discount percentage"
                                                    : "Enter discount amount"
                                            }
                                            className="Coupon-input"
                                            value={formData.percentageOrAmount}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, percentageOrAmount: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label htmlFor="minimumPurchaseAmount" className="input-label">
                                            Minimum Purchase Amount
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter minimum purchase amount"
                                            className="Coupon-input"
                                            value={formData.minimumPurchaseAmount}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, minimumPurchaseAmount: e.target.value }))
                                            }
                                        />
                                    </div>
                                    <div className="Coupon-form-group">
                                        <label htmlFor="percentageOrAmount" className="input-label">
                                            Days Applied On
                                        </label>
                                        <div className="days-container">
                                            {days.map((day) => (
                                                <button
                                                    key={day.key}
                                                    type="button"
                                                    className={`day-btn ${formData.daysAppliedon.includes(day.key) ? "active" : ""}`}
                                                    onClick={() => {
                                                        setFormData((prev) => {
                                                            const appliedDays = prev.daysAppliedon;
                                                            return appliedDays.includes(day.key)
                                                                ? { ...prev, daysAppliedon: appliedDays.filter((d) => d !== day.key) }
                                                                : { ...prev, daysAppliedon: [...appliedDays, day.key] };
                                                        });
                                                    }}
                                                >
                                                    {day.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="Coupon-form-row">
                                    <div className="Coupon-form-group">
                                        <label htmlFor="description" className="input-label">
                                            Description
                                        </label>
                                        <textarea
                                            placeholder="Enter Description"
                                            className="subscription-input"
                                            value={formData.description || ""}
                                            onChange={e => {
                                                let value = e.target.value;

                                                // Auto bullet on Enter
                                                if (value.endsWith("\n")) {
                                                    value += "• ";
                                                }
                                                setFormData(prev => ({ ...prev, description: value }));
                                            }}
                                            style={{ height: '100px' }}
                                        />
                                    </div>
                                </div>
                                <div className="Coupon-buttons">
                                    <button className="add-Coupon-button" type="submit" onClick={handleAddCoupon}>
                                        add Coupon
                                    </button>
                                    <button className="cancel-Coupon-button" onClick={() => navigate('/coupons')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="coupon-widgets">
                                <div className="coupon-widgets-header">
                                    <h3>coupons</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="coupon-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-coupon" onClick={() => navigate('/coupons/add')}>+ Add coupon</button>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {coupons.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No coupons found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            coupons.map((coupon, index) => (
                                                <TableRow key={coupon._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{coupon.couponCode}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}> {coupon.startTime
                                                        ? new Date(coupon.startTime).toISOString().split("T")[0]
                                                        : ""}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{coupon.endTime
                                                        ? new Date(coupon.endTime).toISOString().split("T")[0]
                                                        : ""}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{coupon.discountType === "percentage"
                                                        ? `${coupon.percentageOrAmount}%`
                                                        : `₹${coupon.percentageOrAmount}`}</Typography></TableCell>
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                backgroundColor: coupon.isActive ? '#28A745' : '#C10000',
                                                                color: '#ffffff',
                                                                fontWeight: 600,
                                                                padding: '4px 8px',
                                                                borderRadius: '10px',
                                                                width: '90px',
                                                                maxHeight: '90px',
                                                                textTransform: 'none',
                                                                '&:hover': {
                                                                    backgroundColor: coupon.isActive ? '#218838' : '#a10000',
                                                                },
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                margin: '0 auto',
                                                            }}
                                                        >
                                                            {coupon.isActive ? 'Active' : 'Inactive'}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                debugger;
                                                                setFormData({
                                                                    couponCode: coupon.couponCode || '',
                                                                    startTime: coupon.startTime ? new Date(coupon.startTime) : null,
                                                                    endTime: coupon.endTime ? new Date(coupon.endTime) : null,
                                                                    discountType: coupon.discountType || '',
                                                                    useLimit: coupon.useLimit || '',
                                                                    percentageOrAmount: coupon.percentageOrAmount || '',
                                                                    minimumPurchaseAmount: coupon.minimumPurchaseAmount || '',
                                                                    daysAppliedon: Array.isArray(coupon.daysAppliedon) ? coupon.daysAppliedon : [],
                                                                    description: coupon.description || '',
                                                                    storeId: coupon.storeId || ''
                                                                });
                                                                setEditCouponId(coupon._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(coupon._id)}
                                                            />
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="product-bottom">
                                <div className="product-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    couponCode: '',
                                                    description: '',
                                                    percentageOrAmount: '',
                                                    discountType: '',
                                                    daysAppliedon: '',
                                                    startTime: '',
                                                    endTime: '',
                                                    minimumPurchaseAmount: '',
                                                    useLimit: ''
                                                });

                                            }}
                                        />
                                        <div className="popup-form">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Coupon" : "Add Coupon"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateCoupon}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="couponCode" className="input-label">
                                                            Coupon Code
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter coupon code"
                                                            className="Coupon-input"
                                                            value={formData.couponCode}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, couponCode: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Branch Name</label>
                                                        <select
                                                            className="category-input"
                                                            value={formData.storeId || ""}
                                                            onChange={(e) =>
                                                                setFormData(prev => ({ ...prev, storeId: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Branch</option>
                                                            {stores
                                                                .filter(store =>
                                                                    role === "SuperAdmin" ||
                                                                    (role === "Admin" && JSON.parse(sessionStorage.getItem("storeIds") || "[]").includes(store._id))
                                                                )
                                                                .map(store => (
                                                                    <option key={store._id} value={store._id}>
                                                                        {store.storeName}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="useLimit" className="input-label">
                                                            Use Limit
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter use limit"
                                                            className="Coupon-input"
                                                            value={formData.useLimit}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, useLimit: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="startTime" className="input-label">
                                                            Start Time
                                                        </label>
                                                        <input
                                                            type="datetime-local"
                                                            className="Coupon-input"
                                                            value={formData.startTime ? formData.startTime.toISOString().slice(0, 16) : ''}
                                                            onChange={(e) => setFormData({ ...formData, startTime: new Date(e.target.value) })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="useLimit" className="input-label">
                                                            End Time
                                                        </label>
                                                        <input
                                                            type="datetime-local"
                                                            className="Coupon-input"
                                                            value={formData.endTime ? formData.endTime.toISOString().slice(0, 16) : ''}
                                                            onChange={(e) => setFormData({ ...formData, endTime: new Date(e.target.value) })}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="discountType" className="input-label">
                                                            Discount Type
                                                        </label>
                                                        <select
                                                            id="discountType"
                                                            className="Coupon-input"
                                                            value={formData.discountType}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, discountType: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select Discount Type</option>
                                                            <option value="percentage">Percentage</option>
                                                            <option value="fixed">Fixed</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="percentageOrAmount" className="input-label">
                                                            {formData.discountType === "percentage" ? "Percentage (%)" : "Amount (₹)"}
                                                        </label>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            placeholder={
                                                                formData.discountType === "percentage"
                                                                    ? "Enter discount percentage"
                                                                    : "Enter discount amount"
                                                            }
                                                            className="Coupon-input"
                                                            value={formData.percentageOrAmount}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, percentageOrAmount: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="minimumPurchaseAmount" className="input-label">
                                                            Minimum Purchase Amount
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter minimum purchase amount"
                                                            className="Coupon-input"
                                                            value={formData.minimumPurchaseAmount}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, minimumPurchaseAmount: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="percentageOrAmount" className="input-label">
                                                            Days Applied On
                                                        </label>
                                                        <div className="days-container">
                                                            {days.map((day) => (
                                                                <button
                                                                    type="button"
                                                                    className={`day-btn ${formData.daysAppliedon?.includes(day.key) ? "active" : ""}`}
                                                                    onClick={() => {
                                                                        setFormData(prev => {
                                                                            const appliedDays = prev.daysAppliedon || [];
                                                                            return appliedDays.includes(day.key)
                                                                                ? { ...prev, daysAppliedon: appliedDays.filter(d => d !== day.key) }
                                                                                : { ...prev, daysAppliedon: [...appliedDays, day.key] };
                                                                        });
                                                                    }}
                                                                >
                                                                    {day.label}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="description" className="input-label">
                                                            Description
                                                        </label>
                                                        <textarea
                                                            placeholder="Enter Description"
                                                            className="subscription-input"
                                                            value={formData.description || ""}
                                                            onChange={e => {
                                                                let value = e.target.value;

                                                                // Auto bullet on Enter
                                                                if (value.endsWith("\n")) {
                                                                    value += "• ";
                                                                }
                                                                setFormData(prev => ({ ...prev, description: value }));
                                                            }}
                                                            style={{ height: '100px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && coupons.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more coupons
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Offer?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteCoupon}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </div>
            </div>
        </div>

    );
};

export default OfferPage;
